<h1 class="mb-2">Timeline</h1>
<div class="events mt-2">
    <div class="event" *ngFor="let event of events">
        <h5 [innerHtml]="event.title"></h5>
        <p *ngIf="event.details" [innerHtml]="event.details"></p>
        <div class="event--meta">
            <p *ngIf="event.date">🗓️ {{event.date}}</p>
            <p *ngIf="event.location">📍 {{event.location}}</p>
            <a *ngIf="event.link" class="btn btn-secondary" [attr.href]="event.link" target="_blank" rel="nofollow">💾 Archive</a>
        </div>
    <div>
</div>
